<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="row">
            <div class="col">
              <Filters
                :filters="filters"
                :applying="applying"
                v-on:apply="apply()"
                :hideCompany="filterDisplay.hideCompany"
                :hideRegion="filterDisplay.hideRegion"
                :hideBranch="filterDisplay.hideBranch"
                :hideDevice="filterDisplay.hideDevice"
                :hidePromotionalInfo="filterDisplay.hidePromotionalInfo"
                :hideDate="filterDisplay.hideDate"
              ></Filters>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <b-form-group label-for="keyword" label="Keyword">
                <input
                  id="keyword"
                  type="text"
                  class="form-control"
                  v-model="filters.keyword"
                />
              </b-form-group>
            </div>
            <div class="col"></div>
            <div class="col"></div>
            <div class="col text-center"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <div class="card">
          <div class="card-header">
            <div>
              <i class="fa fa-align-justify"></i> Users ({{ pagination.total }})
            </div>
          </div>
          <div class="card-body">
            <div v-if="!tableReady" class="table-loading-container">
              <img
                src="/img/wifi-loading.gif"
                alt="loading"
                class="loading-table"
              />
            </div>
            <div v-if="tableReady">
              <div v-if="!items.length">
                <b-alert show variant="warning">
                  No Users
                </b-alert>
              </div>
              <table class="table table-striped" v-if="items.length">
                <thead>
                  <tr>
                    <th><a href="#" @click.prevent="sort('name')">Name</a></th>
                    <th>Registered Branch</th>
                    <th class="text-center">
                      <a href="#" @click.prevent="sort('visits')">Visits</a>
                    </th>
                    <th class="text-center">Promotion Status</th>
                    <th class="text-center">
                      <a href="#" @click.prevent="sort('hops')">Branch Hops</a>
                    </th>
                    <th>
                      <a href="#" @click.prevent="sort('dateAdded')"
                        >Date Created</a
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item._id">
                    <td>
                      <i
                        :title="item.isSuperAdmin ? 'Super Admin' : 'Admin'"
                        class="cui-star mr-2"
                        v-if="item.isAdmin || item.isSuperAdmin"
                        :class="{ superAdminStar: item.isSuperAdmin }"
                      ></i>
                      <i
                        title="Holly-Fi User"
                        class="fa fa-wifi mr-2"
                        v-if="
                          !item.isAdmin && !item.isSuperAdmin && !item.isTester
                        "
                      ></i>
                      <i
                        title="Holly-Fi User"
                        class="fa fa-thermometer-half mr-2"
                        v-if="item.isTester"
                      ></i>
                      <router-link
                        :to="{ name: 'Update User', params: { id: item._id } }"
                        >{{ item.firstName }} {{ item.lastName }}</router-link
                      >
                    </td>
                    <td>
                      <div v-if="item.branch">{{ item.branch.name }}</div>
                    </td>
                    <td class="text-center">{{ item.visits }}</td>
                    <td class="text-center">
                      {{
                        item.isActive
                          ? item.promotionalInfo
                            ? "Opted-In"
                            : "Opted-Out"
                          : "InActive"
                      }}
                    </td>
                    <td class="text-center">{{ item.hops }}</td>
                    <td>{{ item.dateAdded | formatDate }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="float-right">
                <button
                  class="btn btn-dark pull-right"
                  type="button"
                  @click="exportData()"
                >
                  Export Data
                </button>
                <a
                  :href="latestDownloadLink"
                  ref="downloadLink"
                  style="display:none;"
                  >Download {{ exportFileName }}</a
                >
              </div>
              <div style="float: left;">
                <div class="mb-2">
                  <b-form-select
                    style="width: 70px;"
                    id="Limit"
                    :options="limitsList"
                    required
                    v-model="pagination.limit"
                  >
                  </b-form-select>
                  <span> Users per page</span>
                </div>
                <nav>
                  <b-pagination
                    :total-rows="pagination.total"
                    :per-page="pagination.limit"
                    v-model="pagination.page"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </b-col> </b-row
    ><!--/.row-->
    <b-modal
      title="Confirm Delete"
      class="modal-danger"
      v-model="deleteModal"
      @ok="confirmDelete()"
      ok-variant="danger"
    >
      <div><b>Are you sure you want to delete this user?</b></div>
      <div>{{ selectedItem.firstName }} {{ selectedItem.lastName }}</div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import common from "./../../mixins/common";
import filter from "./../../mixins/filter";
import Filters from "@/views/common/Filters";
import { promotionalStatusEnum } from "../../helpers/enums/promotionalStatusEnum";

export default {
  name: "userreport",
  components: {
    Filters
  },
  data() {
    return {
      selectedItem: {},
      items: [],
      deleteModal: false,
      tableReady: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        sort: "dateAdded",
        sortDir: -1
      },
      filters: {
        company: null,
        region: null,
        branch: null,
        promotionalInfo: null,
        fromDate: "",
        toDate: "",
        exportData: false,
        allTime: false
      },
      applying: false,
      limits: [10, 50, 100],
      exportFileName: null
    };
  },
  mixins: [common, filter],
  computed: {
    downloadLink() {
      return this.$refs.downloadLink;
    },
    limitsList: function() {
      return this.limits.map(limit => {
        return {
          text: limit,
          value: limit
        };
      });
    },
    latestDownloadLink() {
      if (this.exportFileName) {
        return `/exports/${this.exportFileName}`;
      }
      return null;
    }
  },
  methods: {
    apply() {
      if (this.validate()) {
        this.getItems();
      }
    },
    validate() {
      if (this.filters.fromDate === "" || this.filters.toDate === "") {
        this.showToast("Select a valid date range", "error");
        return false;
      }
      return true;
    },
    getItems: function() {
      let scope = this;
      scope.tableReady = false;

      let search = {
        pagination: scope.pagination,
        where: {}
      };

      if (
        scope.filters.company &&
        scope.filters.region &&
        scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company,
          region: scope.filters.region,
          branch: scope.filters.branch
        };
      } else if (
        scope.filters.company &&
        scope.filters.region &&
        !scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company,
          region: scope.filters.region
        };
      } else if (
        scope.filters.company &&
        !scope.filters.region &&
        !scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company
        };
      }

      if (scope.filters.promotionalInfo) {
        if (scope.filters.promotionalInfo == promotionalStatusEnum.InActive) {
          search.where.isActive = false;
        } else {
          search.where.promotionalInfo =
            scope.filters.promotionalInfo == promotionalStatusEnum.OptedIn;
        }
      }

      if (scope.filters.allTime) {
        search.fromDate = scope.$store.getters.allTime.fromDate;
        search.toDate = scope.$store.getters.allTime.toDate;
      } else {
        search.fromDate = scope.filters.fromDate;
        search.toDate = scope.filters.toDate;
      }
      search.keyword = scope.filters.keyword;

      search.exportData = scope.filters.exportData;

      scope.$store.dispatch("getUserReport", search).then(
        result => {
          scope.items = result.docs;
          scope.exportFileName = result.exportFileName;
          scope.pagination.total = result.total;
          scope.tableReady = true;
          if (scope.exportFileName) {
            //wait for a link dom element
            setTimeout(() => {
              const elemDown = scope.$refs.downloadLink;
              elemDown.click();
            }, 1000);
          }
        },
        error => {
          console.log(error);
          scope.applying = false;
        }
      );
    },
    sort(sortOrder) {
      if (this.pagination.sortDir === -1) {
        this.pagination.sortDir = 1;
      } else {
        this.pagination.sortDir = -1;
      }

      if (sortOrder === "visits" && this.pagination.sort !== "visits")
        this.pagination.sortDir = -1;

      if (sortOrder === "hops" && this.pagination.sort !== "hops")
        this.pagination.sortDir = -1;

      this.pagination.sort = sortOrder;
      this.getItems();
    },
    exportData() {
      this.filters.exportData = true;
      this.apply();
    }
  },
  created() {
    this.filterDisplay.hideRegion = false;
    this.filterDisplay.hideBranch = false;
    this.filterDisplay.hideDevice = false;
    this.filterDisplay.hidePromotionalInfo = false;
    this.filterDisplay.hideDate = false;
    this.setupFilter();
    setTimeout(() => {
      this.getItems();
    }, 1000);
  },
  watch: {
    "pagination.page": function(val) {
      this.getItems();
    },
    "pagination.limit": function(val) {
      this.getItems();
    }
  }
};
</script>
